<template>
  <v-card>
    <v-card-text>
      <v-layout row>
        <v-flex>
          <v-flex xs12>
            <v-text-field
              :value="form.telefono"
              :error-messages="error_input.telefono"
              label="Teléfono"
              @input="(payload) => form.telefono = payload"
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea
              :value="form.direccion.direccion"
              clearable
              :error-messages="error_input.direccion"
              rows="2"
              label="Direccion"
              @input="(payload) => form.direccion.direccion = payload"
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea
              :value="form.direccion.observaciones"
              clearable
              rows="2"
              :error-messages="error_input.observaciones"
              label="Observaciones"
              @input="(payload) => form.direccion.observaciones = payload"
            />
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="grey"
        dark
        @click="close"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="blue darken-1"
        class="white--text"
        :loading="loading"
        :disabled="loading"
        @click="guardar"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "FormDireccionAnonimo",
        props: {
            direccion: {
                type: Object,
                default: () => {
                    return {
                        telefono: 0,
                        direccion: {
                            latitude: 0,
                            longitude: 0,
                            direccion: '',
                            observaciones: '',
                        },
                    }
                }
            },
            urlAction: {
                type: String,
                required: true
            }
        },
        data() {

            return {
                form: Object.assign({}, this.$_clonar(this.direccion)),
                error_input: {},
                loading: false,
            }
        },
        mounted() {

        },
        methods: {
            close() {
                this.$emit('form:close')
            },
            guardar() {
                this.loading = true;
                axios.post(this.urlAction, this.form)
                    .then((responseOk) => {
                        this.loading = false;
                        this.$emit('form:save', responseOk.data.data)
                    })
                    .catch((error) => {
                        this.loading = false;

                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            /*window.console.log(error.response.data);
                            window.console.log(error.response.status);
                            window.console.log(error.response.headers);
                            window.console.info("Es error");*/
                            if (error.response.status === 422) {
                                /*window.console.info("Es error");
                                window.console.log(error.response.data.data);*/
                                this.error_input = Object.assign({}, error.response.data.data)
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            /*window.console.log(error.request);*/
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            /*window.console.log('Error', error.message);*/
                        }
                    });
            },
        }
    }
</script>

<style scoped>

</style>
